import React from 'react';
import { useTimer } from 'react-timer-hook';

export interface MyTimerProps {
  title: string;
  expiryTimestamp: Date;
  onExpire: () => void;
}
export function MyTimer(props: MyTimerProps) {
  const {
    seconds,
    minutes,
    /*hours,
    days,
    isRunning,*/
    start,
    /*pause,
    resume,
    restart,*/
  } = useTimer({
    expiryTimestamp: props.expiryTimestamp.getTime(),
    onExpire: props.onExpire,
  });

  React.useEffect(() => {
    start();
  }, [start]);
  return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ fontSize: '15px' }}>
        <span>{props.title}</span>
        <span>{minutes}</span>:<span>{seconds}</span>
      </div>
    </div>
  );
}
